import React, { ReactNode } from 'react';
import { TopNavigation } from '@/components/molecules';
import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  children: ReactNode;
}

const Container = styled.div`
  max-width: ${rem(414)};
  margin: 0 auto;
  background-color: #ffffff;
`;

const DetailPageLayout = (props: IProps) => {
  const { children } = props;

  return (
    <Container>
      <TopNavigation hasPrevIcon>상세보기</TopNavigation>
      <main>{children}</main>
    </Container>
  );
};

export default DetailPageLayout;
